import { render, staticRenderFns } from "./wandubookvip.vue?vue&type=template&id=1b5ad325&scoped=true"
import script from "./wandubookvip.vue?vue&type=script&lang=js"
export * from "./wandubookvip.vue?vue&type=script&lang=js"
import style0 from "./wandubookvip.vue?vue&type=style&index=0&id=1b5ad325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ad325",
  null
  
)

export default component.exports